import { NgClass, NgStyle } from '@angular/common';
import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
interface ProductColor {
  name: string;
  color: string;
}

@Component({
  selector: 'app-product-color-picker',
  imports: [NgStyle, NgClass, MatIconModule, MatTooltipModule],
  templateUrl: './product-color-picker.html',
  styleUrl: './product-color-picker.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductColorPicker),
      multi: true,
    },
  ],
})
export class ProductColorPicker implements ControlValueAccessor {
  colors: ProductColor[] = [
    { name: 'Black', color: '#000000' },
    { name: 'White', color: '#FFFFFF' },
    { name: 'Pink', color: '#FFC1CC' },
    { name: 'Blue', color: '#0000FF' },
    { name: 'Beige', color: '#F5F5DC' },
    { name: 'Green', color: '#008000' },
    { name: 'Khaki', color: '#C3B091' },
    { name: 'Gray', color: '#666666' },
    { name: 'Red', color: '#FF0000' },
    { name: 'Navy', color: '#000080' },
    { name: 'Light Blue', color: '#ADD8E6' },
    { name: 'Coffee', color: '#4B2E2E' },
    { name: 'Wine', color: '#722F37' },
    { name: 'Yellow', color: '#FFFF00' },
    { name: 'Hot Pink', color: '#FF69B4' },
    { name: 'Purple', color: '#800080' },
    { name: 'Orange', color: '#FFA500' },
    { name: 'Brown', color: '#A52A2A' },
  ];
  value: string = '';

  onColorChanged(color: string) {
    if (this.disabled) return;
    if (this.value === color) {
      this.value = '';
    } else {
      this.value = color;
    }
    this.onChange(this.value);
  }

  onChange: (value: string) => void = () => {};
  onTouched: () => void = () => {};
  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn; // 注册外部的变更回调
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn; // 注册外部的触摸回调
  }

  disabled: boolean = false;
  // 可选：禁用组件
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
